import __var_0__ from './mode.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Chi-squared distribution mode.
*
* @module @stdlib/stats/base/dists/chisquare/mode
*
* @example
* var mode = require( '@stdlib/stats/base/dists/chisquare/mode' );
*
* var v = mode( 11.0 );
* // returns 11.0
*
* v = mode( 1.5 );
* // returns 0.0
*/

// MODULES //
var mode = __var_0__;


// EXPORTS //
export default mode;
